export const handleStoreNoticeDismiss = () => {
	const noticeWrapper = document.querySelector(
		'.woocommerce-store-notice-wrapper'
	);
	if ( ! noticeWrapper ) {
		return;
	}
	const link = noticeWrapper.querySelector(
		'a.woocommerce-store-notice__dismiss-link'
	);
	link.onclick = ( e ) => {
		console.log( 'Click' );
		e.preventDefault();
		noticeWrapper.classList.add( 'd-none' );
		return false;
	};
};
